module.exports = new __parcel__URL__("gradient.0ebd9a08.png").toString();